<template>
  <div id="container">
    <section id="register">
      <div class="wrap">
        <div class="register_step flex">
          <div class="step_box flex on">
            <div class="num">1</div>
            <p>ゲストユーザー情報の登録</p>
          </div>
          <div class="step_box flex on">
            <div class="num">2</div>
            <p>入力内容の確認</p>
          </div>
          <div class="step_box flex">
            <div class="num">3</div>
            <p>ゲストユーザー登録の完了</p>
          </div>
        </div>

        <form @submit="nextClicked">
          <div class="cts_box">
            <h2 class="sub_ttl"><span>入力内容の確認</span></h2>
            <p class="reg_lead">
              <span class="blue bold"
                >すべての入力内容に間違いがないことをご確認ください。<br />
                すべての内容を確認の後、画面下の「ゲストユーザー登録を完了する」ボタンを押して会員登録を完了してください。</span
              ><br /><br />
              入力内容を修正する場合は、該当する項目をクリックして正しい内容を再度入力してください。<br /><br />
              <span class="blue bold"
                >「*」のついている箇所は必須項目です。</span
              >
            </p>

            <form-error-box v-if="errors" />

            <div id="class_change" class="reg_set anchor_point">
              <div class="input_set name">
                <div class="label">おなまえ<span>*</span></div>
                <div class="input_fields flex">
                  <div class="field">
                    <div class="label">姓</div>
                    <input
                      type="text"
                      maxlength="16"
                      v-model="new_user.last_name"
                      v-bind:class="{ error: validation_errors.last_name }"
                      @input="
                        new_user.last_name = replaceHalfToFull(
                          new_user.last_name
                        )
                      "
                      placeholder="例：山田"
                    />
                    <validation-errors
                      :errors="validation_errors.last_name"
                      v-if="validation_errors.last_name"
                    ></validation-errors>
                  </div>
                  <div class="field">
                    <div class="label">名</div>
                    <input
                      type="text"
                      maxlength="16"
                      v-model="new_user.first_name"
                      v-bind:class="{ error: validation_errors.first_name }"
                      @input="
                        new_user.first_name = replaceHalfToFull(
                          new_user.first_name
                        )
                      "
                      placeholder="例：太郎"
                    />
                    <validation-errors
                      :errors="validation_errors.first_name"
                      v-if="validation_errors.first_name"
                    ></validation-errors>
                  </div>
                </div>
              </div>

              <div class="input_set kana">
                <div class="label">フリガナ<span>*</span></div>
                <div class="input_fields flex">
                  <div class="field">
                    <div class="label">姓（全角カナ）</div>
                    <input
                      type="text"
                      maxlength="16"
                      v-model="new_user.last_name_kana"
                      @input="
                        new_user.last_name_kana = replaceHiraToKana(
                          new_user.last_name_kana
                        )
                      "
                      v-bind:class="{ error: validation_errors.last_name_kana }"
                      placeholder="例：ヤマダ"
                    />
                    <validation-errors
                      :errors="validation_errors.last_name_kana"
                      v-if="validation_errors.last_name_kana"
                    ></validation-errors>
                  </div>
                  <div class="field">
                    <div class="label">名（全角カナ）</div>
                    <input
                      type="text"
                      maxlength="16"
                      v-model="new_user.first_name_kana"
                      @input="
                        new_user.first_name_kana = replaceHiraToKana(
                          new_user.first_name_kana
                        )
                      "
                      v-bind:class="{
                        error: validation_errors.first_name_kana,
                      }"
                      placeholder="例：タロウ"
                    />
                    <validation-errors
                      :errors="validation_errors.first_name_kana"
                      v-if="validation_errors.first_name_kana"
                    ></validation-errors>
                  </div>
                </div>
              </div>

              <div class="input_set" v-if="false">
                <div class="label">性別<span>*</span></div>
                <div
                  class="radio"
                  v-bind:class="{ error: validation_errors.gender }"
                >
                  <input
                    id="radio01"
                    type="radio"
                    v-model="new_user.gender"
                    value="male"
                  />
                  <label for="radio01">男性</label>

                  <input
                    id="radio02"
                    type="radio"
                    v-model="new_user.gender"
                    value="female"
                  />
                  <label for="radio02">女性</label>

                  <input
                    id="radio03"
                    type="radio"
                    v-model="new_user.gender"
                    value="secret"
                  />
                  <label for="radio03">その他</label>
                </div>
                <validation-errors
                  :errors="validation_errors.gender"
                  v-if="validation_errors.gender"
                ></validation-errors>
              </div>

              <div class="input_set birth" v-if="false">
                <div class="label">生年月日<span>*</span></div>
                <p>すべての欄に半角数字でご入力下さい。</p>
                <div class="input_fields flex">
                  <div class="field">
                    <input
                      type="text"
                      v-model="new_user.birthday_year"
                      @input="
                        new_user.birthday_year = replaceFullToHalf(
                          new_user.birthday_year
                        )
                      "
                      v-bind:class="{ error: validation_errors.birthday_year }"
                      placeholder="年"
                    />
                    <validation-errors
                      :errors="validation_errors.birthday_year"
                      v-if="validation_errors.birthday_year"
                    ></validation-errors>
                  </div>
                  <div class="field">
                    <input
                      type="text"
                      v-model="new_user.birthday_month"
                      @input="
                        new_user.birthday_month = replaceFullToHalf(
                          new_user.birthday_month
                        )
                      "
                      v-bind:class="{ error: validation_errors.birthday_month }"
                      placeholder="月"
                    />
                    <validation-errors
                      :errors="validation_errors.birthday_month"
                      v-if="validation_errors.birthday_month"
                    ></validation-errors>
                  </div>
                  <div class="field">
                    <input
                      type="text"
                      v-model="new_user.birthday_day"
                      @input="
                        new_user.birthday_day = replaceFullToHalf(
                          new_user.birthday_day
                        )
                      "
                      v-bind:class="{ error: validation_errors.birthday_day }"
                      placeholder="日"
                    />
                    <validation-errors
                      :errors="validation_errors.birthday_day"
                      v-if="validation_errors.birthday_day"
                    ></validation-errors>
                  </div>
                </div>
              </div>

              <div class="input_set kana">
                <div class="label">ユーザーネーム（表示名）<span>*</span></div>
                <p>
                  複眼経済塾WEBサイト上で他のゲストユーザーに表示されるお名前です。ログイン後に「マイページ」で変更できます。
                </p>
                <input
                  type="text"
                  class="nickname"
                  v-bind:class="{ error: validation_errors.humhub_username }"
                  v-model="new_user.humhub_username"
                />
                <ValidationErrors
                  :errors="validation_errors.humhub_username"
                  v-if="validation_errors.humhub_username"
                ></ValidationErrors>
              </div>

              <div class="input_set email">
                <div class="label">連絡先メールアドレス<span>*</span></div>
                <input
                  type="text"
                  class="email"
                  v-bind:class="{ error: validation_errors.email }"
                  v-model="new_user.email"
                />
                <ValidationErrors
                  :errors="validation_errors.email"
                  v-if="validation_errors.email"
                ></ValidationErrors>
              </div>

              <div class="input_set email">
                <div class="label">
                  連絡先メールアドレス(確認)<span>*</span>
                </div>
                <input
                  type="text"
                  class="email"
                  v-bind:class="{ error: validation_errors.email_confirmation }"
                  v-model="new_user.email_confirmation"
                />
                <ValidationErrors
                  :errors="validation_errors.email_confirmation"
                  v-if="validation_errors.email_confirmation"
                ></ValidationErrors>
              </div>

              <div class="input_set phone" v-if="false">
                <div class="label">連絡先電話番号<span>*</span></div>
                <p>（半角数字で日中連絡の取れるお電話番号をご入力下さい。）</p>
                <input
                  type="tel"
                  v-model="new_user.phone_number"
                  v-bind:class="{ error: validation_errors.phone_number }"
                  @input="
                    new_user.phone_number = replaceFullToHalf(
                      new_user.phone_number
                    )
                  "
                  placeholder="例：09012345678"
                />
                <validation-errors
                  :errors="validation_errors.phone_number"
                  v-if="validation_errors.phone_number"
                ></validation-errors>
              </div>

              <div class="input_set addr" v-if="false">
                <div class="label">郵便番号<span>*</span></div>
                <p>（半角数字）</p>
                <div class="input_fields flex">
                  <div class="field">
                    <input
                      type="text"
                      v-model="new_user.zip"
                      v-bind:class="{ error: validation_errors.zip }"
                      name="zip"
                      @input="new_user.zip = replaceFullToHalf(new_user.zip)"
                      placeholder="例：100-1234"
                    />
                    <validation-errors
                      :errors="validation_errors.zip"
                      v-if="validation_errors.zip"
                    ></validation-errors>
                  </div>
                  <div class="field">
                    <button
                      type="button"
                      class="ajaxzip3"
                      v-on:click="zipSearch"
                    >
                      郵便番号から住所を取得
                    </button>
                  </div>
                </div>
              </div>

              <div class="input_set addr" v-if="false">
                <div class="label">都道府県名<span>*</span></div>
                <p>
                  （選択して下さい
                  ※海外にお住まいの方は「日本国外に居住」を選択のうえ国内の送付先住所を「送付先住所指定フォーム」にご入力ください）
                </p>
                <PrefectureSelect
                  :prefecture="new_user.prefecture"
                  name="prefecture"
                  v-bind:class="{ error: validation_errors.prefecture }"
                  v-on:changed="prefectureChanged"
                />
                <validation-errors
                  :errors="validation_errors.prefecture"
                  v-if="validation_errors.prefecture"
                ></validation-errors>
              </div>

              <div class="input_set addr" v-if="false">
                <div class="label">市区町村<span>*</span></div>
                <input
                  type="text"
                  v-model="new_user.address1"
                  v-bind:class="{ error: validation_errors.address1 }"
                  @input="
                    new_user.address1 = replaceHalfToFull(new_user.address1)
                  "
                  name="address1"
                  placeholder="例：新宿区"
                />
                <validation-errors
                  :errors="validation_errors.address1"
                  v-if="validation_errors.address1"
                ></validation-errors>
              </div>

              <div class="input_set addr" v-if="false">
                <div class="label">地名・番地<span>*</span></div>
                <input
                  type="text"
                  v-model="new_user.address2"
                  v-bind:class="{ error: validation_errors.address2 }"
                  @input="
                    new_user.address2 = replaceHalfToFull(new_user.address2)
                  "
                  placeholder="例：３丁目１３番地"
                />
                <validation-errors
                  :errors="validation_errors.address2"
                  v-if="validation_errors.address2"
                ></validation-errors>
              </div>

              <div class="input_set addr" v-if="false">
                <div class="label">建物名・部屋番号<span></span></div>
                <input
                  type="text"
                  v-model="new_user.address3"
                  v-bind:class="{ error: validation_errors.address3 }"
                  @input="
                    new_user.address3 = replaceHalfToFull(new_user.address3)
                  "
                  placeholder="例：複眼ビル１１１号室"
                />
                <validation-errors
                  :errors="validation_errors.address3"
                  v-if="validation_errors.address3"
                ></validation-errors>
              </div>

              <div class="input_set">
                <div class="label">パスワード</div>
                <p>（8文字以上の半角英数記号）</p>
                <div class="pswd_box flex">
                  <input
                    v-bind:type="password_type ? 'text' : 'password'"
                    v-model="new_user.password"
                    class="password"
                    @input="
                      new_user.password = replaceFullToHalf(new_user.password)
                    "
                    placeholder="8文字以上"
                  />
                  <div class="checkbox">
                    <input
                      id="check01"
                      type="checkbox"
                      v-model="password_type"
                      value="1"
                    />
                    <label for="check01">入力内容を表示</label>
                  </div>
                </div>
                <validation-errors
                  :errors="validation_errors.password"
                  v-if="validation_errors.password"
                ></validation-errors>
              </div>
              <div class="input_set">
                <div class="label">確認のためにもう一度入力</div>
                <p>（8文字以上の半角英数記号）</p>
                <div class="pswd_box flex">
                  <input
                    v-bind:type="
                      password_confirmation_type ? 'text' : 'password'
                    "
                    @input="
                      new_user.password_confirmation_type = replaceFullToHalf(
                        new_user.password_confirmation_type
                      )
                    "
                    v-model="new_user.password_confirmation"
                    class="password"
                    placeholder="8文字以上"
                  />
                  <div class="checkbox">
                    <input
                      id="check02"
                      type="checkbox"
                      v-model="password_confirmation_type"
                      value="1"
                    />
                    <label for="check02">入力内容を表示</label>
                  </div>
                </div>
                <validation-errors
                  :errors="validation_errors.password_confirmation"
                  v-if="validation_errors.password_confirmation"
                ></validation-errors>
              </div>
            </div>

            <p class="alnC mb20">
              すべての項目を確認の上でこちらのボタンを押してください。
            </p>
            <div class="button_wrap">
              <input
                type="submit"
                class="submit light arrow"
                value="ゲストユーザー登録を完了する"
              />
            </div>
          </div>
        </form>
      </div>
      <!--//.wrap-->
    </section>
  </div>
</template>

<script>
import Libraries from "@/components/Libraries.vue";
import ValidationErrors from "@/components/ValidationErrors.vue";
import FormErrorBox from "@/elements/FormErrorBox.vue";
import PrefectureSelect from "@/components/PrefectureSelect";

export default {
  mixins: [Libraries],
  components: {
    ValidationErrors,
    PrefectureSelect,
    FormErrorBox,
  },
  data() {
    if (!this.$store.state.user) {
      this.$router.push({
        name: "UsersRegistration",
        params: this.$route.params,
      });
      return;
    }
    let _new_user = {};
    for (const [key, value] of Object.entries(this.$store.state.user)) {
      _new_user[key] = value;
    }
    return {
      request_exec: false,
      new_user: this.$store.state.user,
      validation_errors: {},
      errors: null,
      password_type: false,
      password_confirmation_type: false,
      show_rank: false,
      rank_name: null,
      rank_payment: null,
      show_shikiho_account: this.$store.state.user.shikiho_account !== null,
    };
  },

  mounted() {
    this.updateRankGuide();
    window.$(".acc_menu .acc_cts").hide();
    window.$(".top_cts.acc_menu .acc_cts").show();
    window.$(".acc_menu .acc_tab").on("click", function () {
      window.$(this).next(".acc_cts").slideToggle();
      window.$(this).toggleClass("open");
    });

    // for jquery.
    window.$(".matrix .info span").on("click", function () {
      if (window.$(this).hasClass("open")) {
        window.$(".matrix_cell .info span").removeClass("open");
        window.$(".matrix_cell .info .info_box").hide();
        window.$(this).closest(".matrix_cell").find(".info_box").fadeOut(300);
        window.$(this).removeClass("open");
      } else {
        window.$(".matrix_cell .info span").removeClass("open");
        window.$(".matrix_cell .info .info_box").hide();
        window.$(this).closest(".matrix_cell").find(".info_box").fadeIn(300);
        window.$(this).addClass("open");
      }
    });
    window
      .$(".matrix .info_box .colse_btn,.matrix .info_box a")
      .on("click", function () {
        window
          .$(this)
          .closest(".matrix_cell")
          .find(".info span")
          .removeClass("open");
        window.$(this).closest(".matrix_cell").find(".info_box").fadeOut(300);
      });
    window.$(".matrix .tggle_btn").on("click", function () {
      window.$(this).closest(".matrix_col");
      window.$(this).closest(".matrix_col").find(".sp_open_cts").slideToggle();
      window.$(this).closest(".matrix_col").toggleClass("open");
    });
  },
  methods: {
    prevClicked() {
      this.$router.push({
        name: "UsersConfirmatioFreenPage1",
        params: this.$route.params,
      });
    },
    nextClicked(event) {
      if (this.request_exec) return;
      this.request_exec = true;

      event.preventDefault();
      this.validation_errors = {};
      this.errors = null;

      this.new_user.password_validates = true;

      this.startUpload();
      this.axios
        .post(`${this.env.api_base_url}users/create.json`, {
          validate: "free_update",
          user: this.new_user,
          campaign_code: this.new_user.campaign_code,
        })
        .then((response) => {
          this.$router.push({
            name: "UsersConfirmationFreeFinish",
            params: { token: response.data.token },
          });
        })
        .catch((error) => {
          if (error.response.data.validation_errors) {
            this.scrollTop();
            this.errors = true;
            this.validation_errors = error.response.data.validation_errors;
          }
          if (error.response.data && error.response.data.error) {
            // TODO: エラー処理
            // this.errors = [error.response.data.error]
          }
          this.$forceUpdate();
        })
        .finally(() => {
          this.finishUpload();
          this.request_exec = false;
        });
    },
    prefectureChanged(prefecture) {
      this.new_user.prefecture = prefecture;
      //this.$forceUpdate()
    },
    optPrefectureChanged(prefecture) {
      this.new_user.opt_prefecture = prefecture;
      //this.$forceUpdate()
    },
    zipSearch() {
      if (this.new_user.zip) {
        this.addressSearch(this.new_user.zip).then((data) => {
          this.new_user.prefecture = data.pref;
          this.new_user.address1 = data.address;
          this.$forceUpdate();
        });
      }
    },
    enablePrimaryAddressClicked() {
      if (this.new_user.enable_primary_address) {
        this.new_user.opt_zip = this.new_user.zip;
        this.new_user.opt_prefecture = this.new_user.prefecture;
        this.new_user.opt_address1 = this.new_user.address1;
        this.new_user.opt_address2 = this.new_user.address2;
        this.new_user.opt_address3 = this.new_user.address3;
        this.$forceUpdate();
      }
    },
    optZipSearch() {
      if (this.new_user.opt_zip) {
        this.addressSearch(this.new_user.opt_zip).then((data) => {
          this.new_user.opt_prefecture = data.pref;
          this.new_user.opt_address1 = data.address;
          this.$forceUpdate();
        });
      }
    },
    updateRankGuide() {
      this.rank_name = {
        rank_regular_plus_month: "本科プラス",
        rank_regular_plus_year: "本科プラス",
        rank_regular_month: "本科",
        rank_regular_year: "本科",
        rank_regular_shikiho_premium_year: "本科",
        rank_regular_shikiho_basic_year: "本科",
        rank_preparatory_month: "予科",
      }[this.new_user.rank];

      this.rank_payment = {
        rank_regular_plus_month: "月額払い",
        rank_regular_plus_year: "年額払い",
        rank_regular_month: "月額払い",
        rank_regular_year: "年額払い",
        rank_regular_shikiho_premium_year: "年額払い",
        rank_regular_shikiho_basic_year: "年額払い",
        rank_preparatory_month: "月額払い",
      }[this.new_user.rank];
    },
  },
};
</script>
